import React from "react";

export default function AppToolbar({ left = null, right = null, className = "", children = null }) {
  const classes = ["ds-toolbar", className].filter(Boolean).join(" ");

  if (children) {
    return <div className={classes}>{children}</div>;
  }

  return (
    <div className={classes}>
      <div className="ds-toolbar__group ds-toolbar__group--left">{left}</div>
      <div className="ds-toolbar__group ds-toolbar__group--right">{right}</div>
    </div>
  );
}
